/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ValidationSource = core.serialization.enum_([
    "required-constraint",
    "unique-constraint",
    "custom-logic",
    "unlinked",
    "invalid-option",
    "is-artifact",
]);
